import { Container } from "semantic-ui-react";

export const CustomerManagerHome = () => {

  return (
    <Container>
      CustomerManager home
    </Container>
  )
};